import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AutoInsuranceAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do you have valid auto insurance on your ',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: 'Auto Insurance',
    additionalFormComponent: 'VehicleInsuranceForm',
  };
  skipConditionsExists = true;
  skipConditions = {
    value: false,
    stepToGo: 13,
  };
}
